import type BookingServiceStaffGroupType from 'owa-service/lib/contract/BookingServiceStaffGroupType';
import type { BookingServiceStaffGroup } from 'owa-graph-schema';

const mapBookingServiceStaffGroupType = (
    staffGroups: BookingServiceStaffGroupType[] | undefined
): BookingServiceStaffGroup[] | undefined => {
    if (!staffGroups) {
        return;
    }
    const modifiedStaffGroups: BookingServiceStaffGroup[] =
        staffGroups?.map(({ StaffGroupGuid = '', StaffList = [] }) => ({
            staffGroupGuid: StaffGroupGuid as string,
            staffList: StaffList as string[],
        })) ?? [];
    return modifiedStaffGroups;
};

export default mapBookingServiceStaffGroupType;
